module.exports = __webpack_public_path__ + "img/racetrack-kenilworth-turf.8afed99a.svg";